<template>
  <div class="nav-bar">
    <div class="logo">
      <img :src="config.logo" @click="routeTo('/')">
      <div v-if="info" class="brand text-ellipsis" @click="routeTo('/')">{{info.school.name}}</div>
      <i v-if="info && (info.role & 4) === 4" class="iconfont" @click="openSchoolPanel">&#xe63a;</i>
    </div>
    <div class="menu-list">
      <div class="menu-item hide-xs-only">
        <div class="menu-box">
          <label @click="routeTo('/')">首页</label>
        </div>
      </div>
      <div class="menu-item hide-xs-only">
        <div class="menu-box">
          <label @click="routeTo(`/papers`)">政策信息</label>
        </div>
      </div>
      <div class="menu-item hide-xs-only" @mouseenter="showCategory = true" @mouseleave="showCategory = false">
        <div class="menu-box">
          <label @click="routeTo(`/reports`)">专项评估</label>
        </div>
        <transition enter-active-class="animated fadeIn" mode="out-in" leave-active-class="animated fadeOut" :duration="{leave: 300}">
          <div v-if="showCategory" class="sub-menu-list">
            <div class="sub-menu-item" @click="routeTo(`/reports?l=100`)">市级评估</div>
            <div class="sub-menu-item" @click="routeTo(`/reports?l=101`)">区级评估</div>
            <div class="sub-menu-item" @click="routeTo(`/reports?l=102`)">其它评估</div>
          </div>
        </transition>
      </div>
      <div class="menu-item hide-xs-only">
        <div class="menu-box">
          <label style="cursor: not-allowed">年度工作报表</label>
        </div>
      </div>
    </div>
    <div class="menu-list">
      <div v-if="isLogin" class="menu-item me" @mouseenter.prevent="showInfo = true" @mouseleave.prevent="showInfo = false">
        <div class="menu-box">
          <label>
            <span>{{info.realName}}</span>
            <i v-if="!showInfo" class="iconfont" @click="showInfo = true">&#xe603;</i>
            <i v-else class="iconfont" @click="showInfo = false">&#xe7de;</i>
          </label>
        </div>
        <transition enter-active-class="animated fadeIn" mode="out-in" leave-active-class="animated fadeOut" :duration="{leave: 300}">
          <div v-if="showInfo" class="sub-menu-list">
            <div class="sub-menu-item" @click="routeTo('/profile')">用户中心</div>
            <div v-if="(info.role & 4) === 4" class="sub-menu-item" @click="openSchoolPanel">切换学校</div>
            <div class="sub-menu-item" @click="handleLogout">
              <span>退出</span>
              <i class="iconfont">&#xe637;</i>
            </div>
          </div>
        </transition>
      </div>
      <div v-else class="menu-item">
        <div class="menu-box">
          <label @click="toLogin">登录</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { page as categoryPage } from '@/api/category'

export default {
  name: 'NavBar',
  components: {},
  data () {
    return {
      showInfo: false,
      showCategory: false,
      categories: []
    }
  },
  watch: {
    $route: {
      async handler (val) {
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(['info', 'isLogin', 'config'])
  },
  created: function () {
    this.fetchCategories()
  },
  methods: {
    fetchCategories() {
      categoryPage({pn: 1, ps: 100, s: 1, t: 100, sort: '+rank'}).then(resp => {
        if (resp.code === 0) {
          this.categories = resp.data.rows
        }
      })
    },
    handleLogout() {
      this.showInfo = false
      this.$store.dispatch('Logout').then(resp => {
        const path = this.$route.path
        this.$router.push(`/login?t=${path}`)
      })
    },
    toLogin() {
      this.$router.push('/login')
    },
    routeTo(url) {
      this.$router.push(url)
    },
    openSchoolPanel() {
      this.$root.$children[0].$refs['changeSchool'].showPanel = true
      this.showInfo = false
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
  @import "../../../styles/variables";
  .nav-bar {
    position: sticky !important;
    z-index: 1000;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 112px;
    // background: linear-gradient(left,hsla(0, 0%, 90%, .92), hsla(240, 3%, 94%, .98));
    background: @white1-color;
    box-shadow:  0 2px 2px -1px rgba(0, 0, 0, 0.2);
    .logo {
      display: flex;
      align-items: center;
      img {
        cursor: pointer;
        height: 80px;
        margin-right: 15px;
      }
      .brand {
        cursor: pointer;
        font-size: 32px;
        font-weight: 300;
      }
      i {
        cursor: pointer;
        font-size: 32px;
        color: @black3-color;
        margin-left: 12px;
      }
    }
    .menu-list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-weight: 300;
      font-size: 32px;
      height: 100%;
      .menu-item {
        height: 100%;
        display: block;
        &.me {
          min-width: 180px;
        }
        .menu-box {
          height: 100%;
          display: flex;
          align-items: center;
          label {
            color: @black3-color;
            cursor: pointer;
            padding: 0 20px;
            border-right: 1px solid @grey3-color;
            .iconfont {
              margin-left: 5px;
              font-size: 20px;
            }
          }
        }
        &.active {
          label {
            font-weight: 400;
          }
        }
        &:last-child {
          label {
            border-right: none;
          }
        }
        &:hover {
          background: linear-gradient(top, RGBA(220, 219, 218, 1), RGBA(240, 239, 239, 1));
          label {
            font-weight: 400;
            color: @black2-color;
          }
        }
        .sub-menu-list {
          z-index: 100;
          background: RGBA(232, 231, 230, 0.98);
          display: block;
          padding: 10px 0;
          .sub-menu-item {
            padding: 10px 20px;
            cursor: pointer;
            i {
              font-size: 28px;
            }
            &:hover {
              font-weight: 400;
              color: @black2-color;
            }
          }
        }
      }
    }
  }
  @media (max-width: @screen-xs-max) {
    .nav-bar {
      height: 300px;
      box-shadow:  0 6px 6px -3px rgba(0, 0, 0, 0.2);
      padding: 0 60px;
      justify-content: space-between;
      .logo {
        img {
          height: 220px;
        }
        .brand {
          font-size: 90px;
        }
        i {
          font-size: 90px;
          margin-left: 30px;
        }
      }
      .menu-list {
        font-size: 90px;
        .menu-item {
          &.me {
            min-width: 540px;
          }
          .menu-box {
            justify-content: flex-end;
            label {
              width: 100%;
              padding: 0 60px;
              text-align: center;
              .iconfont {
                font-size: 60px;
                margin-left: 15px;
              }
            }
          }
          .sub-menu-list {
            padding: 30px 0;
            .sub-menu-item {
              padding: 30px 60px;
              i {
                font-size: 90px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/NavBar.vue